export const Paths = {
    default: '/api/customer-portal/payments/SendInvoice',
};
